export const WCAG_COLORS = {
    primary: {
        defaultColor: "#3E71D2",
        wcagColor: "#125df3"
    },
    "primary-hover": {
        defaultColor: "#3866BD",
        wcagColor: "#0c52df"
    },
    "primary-pressed": {
        defaultColor: "#325AA8",
        wcagColor: "#0a49c7"
    },
    "primary-pressed-256bde": {
        defaultColor: "#376fcb",
        wcagColor: "#0a49c7"
    },
    "primary-disabled": {
        defaultColor: "#ABAFB3",
        wcagColor: "#729ff8"
    },
    secondary: {
        defaultColor: "#2EA581",
        wcagColor: "#28873a"
    },
    "secondary-hover": {
        defaultColor: "#2EA074",
        wcagColor: "#217a32"
    },
    "secondary-pressed": {
        defaultColor: "#298E70",
        wcagColor: "#176a28"
    },
    "secondary-disabled": {
        defaultColor: "#ABAFB3",
        wcagColor: "#bcd8bf"
    },
    warning: {
        defaultColor: "#f29500",
        wcagColor: "#e16509"
    },
    "warning-hover": {
        defaultColor: "#f6b54d",
        wcagColor: "#d75f04"
    },
    "warning-text": {
        defaultColor: "#ffffff",
        wcagColor: "#261102"
    },
    attention: {
        defaultColor: "#ffd600",
        wcagColor: "#ba8405"
    },
    "attention-hover": {
        defaultColor: "#ffeb82",
        wcagColor: "#966101"
    },
    "attention-text": {
        defaultColor: "#ffffff",
        wcagColor: "#281A00"
    },
    "placeholder-text": {
        defaultColor: "#d4d4d4",
        wcagColor: "#ba8405"
    },
    "border-form": {
        defaultColor: "#d4d4d4",
        wcagColor: "#949494"
    },
    "icon-custom-color": {
        defaultColor: "#d4d4d4",
        wcagColor: "#737373"
    }

};
